import * as React from 'react';
import * as styles from "./Menu.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { MenuItem } from './menuItem/MenuItem';
import { IAppPage } from '../../../interfaces/IAppPage';

export interface IMenuProps {
  store?: AppStore;
}

@inject('store')
@observer
export class Menu extends React.Component<IMenuProps> {

  public render(): JSX.Element {
    const menu = [];
    this.props.store.instance.settings.menu.forEach((page: IAppPage, index) => {
      if (page.components) {
        if (page.components[0] != undefined && page.components[0].type === "ExternalLink") {
          menu.push(
            <a
              href={page.components[0].url}
              target={"_blank"}
              data-interception="off"
              key={`tab_${index}`}
            >
              <MenuItem
                icon={page.icon}
                title={page.title}
                iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.menuHighlightColor : this.props.store.instance.settings.design.menuContentColor}
                titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.menuHighlightColor : this.props.store.instance.settings.design.menuContentColor}
                onClick={() => {
                  if (this.props.store.preview) {
                    this.props.store.selectedPageIndex = index;
                  }
                }}
              />
            </a>
          );
        } else {
          menu.push(
            <MenuItem
              key={`tab_${index}`}
              icon={page.icon}
              title={page.title}
              iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.menuHighlightColor : this.props.store.instance.settings.design.menuContentColor}
              titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.menuHighlightColor : this.props.store.instance.settings.design.menuContentColor}
              onClick={() => {
                this.props.store.selectedPageIndex = index;
                this.props.store.showMenu = false;
                document.getElementById("IA_contentArea").scrollTop = 0
              }}
            />
          );
        }
      }
    });
    return (
      <div>
        <div
          className={styles.IA_menu}
          style={{
            display: this.props.store.showMenu ? "block" : "none",
          }}
          onClick={() => {
            this.props.store.showMenu = false;
          }}
        />
        <div
          className={styles.IA_menuPanel}
          style={{
            backgroundColor: this.props.store.instance.settings.design.menuColor,
            left: this.props.store.showMenu ? 0 : "-85%",
            top: window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70,
            height: `calc(100% - ${window.platform === "android" ? 0 : this.props.store.isIPhoneXType ? 40 : 20}px)`
          }}
        >
          {menu}
        </div>
      </div>
    );
  }
}